'use strict';

import React from 'react';
import { cn } from '@src/utils/ui';

const SkeletonCard = () => (
    <div
        data-testid="skeleton-card"
        className={cn(
            'tw-min-w-[240px] tw-max-w-[450px] tw-w-full',
            'tw-flex tw-flex-col tw-items-start tw-self-stretch',
            'tw-border tw-border-[#e0e0e0] tw-bg-white tw-rounded-none',
            'tw-animate-pulse'
        )}
    >
        {/* Image placeholder - 200px like real card */}
        <div className="tw-w-full tw-h-[200px] tw-bg-gray-200" />

        {/* Details section */}
        <div className="tw-flex tw-flex-col tw-w-full tw-p-[16px] tw-gap-[12px]">
            {/* Name */}
            <div className="tw-h-[14px] tw-w-3/4 tw-bg-gray-200 tw-rounded" />

            {/* Price */}
            <div className="tw-flex tw-items-center tw-gap-[4px]">
                <div className="tw-h-[14px] tw-w-[16px] tw-bg-gray-200 tw-rounded" />
                <div className="tw-h-[14px] tw-w-[80px] tw-bg-gray-200 tw-rounded" />
            </div>

            {/* Location */}
            <div className="tw-flex tw-items-center tw-gap-[4px]">
                <div className="tw-h-[14px] tw-w-[16px] tw-bg-gray-200 tw-rounded" />
                <div className="tw-h-[14px] tw-w-[100px] tw-bg-gray-200 tw-rounded" />
            </div>

            {/* Rating */}
            <div className="tw-flex tw-items-center tw-gap-[4px]">
                <div className="tw-h-[14px] tw-w-[16px] tw-bg-gray-200 tw-rounded" />
                <div className="tw-h-[14px] tw-w-[40px] tw-bg-gray-200 tw-rounded" />
            </div>
        </div>

        {/* Badges */}
        <div className="tw-flex tw-p-[16px] tw-pt-0 tw-gap-[8px]">
            <div className="tw-h-[30px] tw-w-[90px] tw-bg-gray-200 tw-rounded-[4px]" />
            <div className="tw-h-[30px] tw-w-[80px] tw-bg-gray-200 tw-rounded-[4px]" />
        </div>
    </div>
);

export const LatestListingsSkeleton = ({ count = 12 }) => (
    <div
        className="section-latest-listings mx-auto tw-clear-both"
        aria-busy="true"
        aria-label="Loading listings"
        role="status"
    >
        <div
            className={cn(
                'latest-listings-title tw-flex tw-flex-col tw-w-full tw-h-[156px]',
                'tw-pt-[60px] tw-pb-[24px] tw-px-[16px] tw-gap-[20px]',
                'tw-text-center tw-justify-center',
                'md:tw-px-[32px]',
                'lg:tw-px-[48px]',
                'xl:tw-px-[64px]',
                '2xl:tw-px-[160px]'
            )}
        >
            <div className="tw-h-[24px] tw-w-[160px] tw-bg-gray-200 tw-rounded tw-mx-auto tw-animate-pulse" />
            <div className="tw-w-[70px] tw-h-[4px] tw-bg-gray-200 tw-mx-auto tw-animate-pulse" />
        </div>

        <div
            className={cn([
                'sc-list',
                'tw-grid',
                'tw-gap-[34px]',
                'tw-w-full',
                'tw-max-w-[1600px]',
                'tw-mx-auto',
                'tw-justify-items-center',
                'tw-grid-cols-1',
                'md:tw-grid-cols-2',
                'lg:tw-grid-cols-3',
                'xl:tw-grid-cols-4',
                'tw-px-[16px]',
                'md:tw-px-[32px]',
                'lg:tw-px-[48px]',
                'xl:tw-px-[64px]',
                '2xl:tw-px-[160px]'
            ])}
        >
            {Array.from({ length: count }, (_, i) => (
                <SkeletonCard key={i} />
            ))}
        </div>
    </div>
);
